import {
  Injectable
} from '@angular/core';
import {
  Observable
,
  BehaviorSubject
,
  Subscription
} from 'rxjs';

import {
  HttpParams
} from '@angular/common/http';
import {
  GridDataResult
} from '@progress/kendo-angular-grid';
import {
  ApiService
} from '../../../../services/api/api.service';
import {UserContext} from '../../../../services/user-context';

@Injectable()
export class PublicationsService extends BehaviorSubject<GridDataResult> {
  public subscription: Subscription;

  constructor(private api: ApiService, private userContext: UserContext) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));
  }

  public getPublications(page: number, limit: number, cb?: any) {
    const params = new HttpParams()
      .set('page', page.toLocaleString())
      .set('limit', limit.toString());

    this.subscription = this.api.get<GridDataResult>(`/account/${(this.userContext.account || {}).id}/publication`, params)
      .subscribe(result => {
        super.next(result);
        if( cb ) {
          cb();
        }
      }, error => {
        console.log("Error getting waivers.");
        if( cb ) {
          cb();
        }
      });
  }
}
